import { timestampDTOSchema } from '@tempo-io/common-dto';
import { z } from 'zod';

export const productDTOSchema = z.object({
  id: z.number(),
  monetizeNowId: z.string(),
  customId: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  status: z.enum(['ACTIVE', 'INACTIVE']),
  type: z.enum(['ADVANCE', 'USAGE', 'ONETIME']),
  ...timestampDTOSchema.shape,
});
